import React from 'react'
import styles from './Loader.module.scss'
import cn from 'classnames'

const Loader = () => {
  return (
    <div className={styles.loader}>
      <div className={cn(styles.loader__dot, styles.loader__dot1)}></div>
      <div className={cn(styles.loader__dot, styles.loader__dot2)}></div>
    </div>
  )
}

export default Loader;